import React from 'react'

interface FlexBetweenRowProps {
  children: React.ReactNode
  style?: React.CSSProperties
}

const FlexBetweenRow: React.FC<FlexBetweenRowProps> = ({ children, style }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0', ...style }}>
    {children}
  </div>
)

export default FlexBetweenRow
